import mismaClave from './mismaClave.js';

/**
 * Lo que hay en memoria, **solo si es la respuesta de lo que se está mirando ahora**.
 *
 * El carril (`carrilPeticiones`) resuelve que conteste la última petición y que una respuesta
 * caducada no llegue a escribirse. Lo que no resuelve es el hueco de en medio: entre pulsar y que
 * llegue la respuesta, la pantalla ya dice que es otro año —u otra pestaña, u otras fechas—
 * mientras sigue enseñando los datos de antes. Y como lo de antes viene con sus botones puestos,
 * no es solo que la cabecera no cuadre: se puede pulsar «Anular» o «Denegar» sobre una solicitud
 * que no es la que se cree.
 *
 * Esto pasó una vez por fuente de datos y una por ronda de revisión: la vista previa de solicitar
 * con las fechas recién cambiadas, la bandeja del aprobador al cambiar de pestaña o de año, y el
 * resumen de «Mis vacaciones» al cambiar de año (revisiones CODEX de los PR #1733 y #1735). Cada
 * una se tapó con su propia comparación, así que la siguiente fuente volvía a olvidarla. La
 * comparación vive en `mismaClave`: una fuente nueva solo tiene que decir **de qué es** su
 * respuesta.
 *
 *   // el resumen que se puede pintar: el del año que se está mirando, o nada
 *   resumenVigente: function () {
 *     const r = this.resumen;
 *     return respuestaVigente(r, r && r.anio, this.anio);
 *   }
 *
 * @param respuesta la última respuesta recibida, o `null`
 * @param deLaRespuesta de qué es esa respuesta: lo que ella misma declara
 * @param enPantalla de qué es lo que se está mirando
 * @returns la respuesta si es la de ahora, `null` si no
 */
export default function respuestaVigente(respuesta, deLaRespuesta, enPantalla) {
  if (!respuesta) return null;
  return mismaClave(deLaRespuesta, enPantalla) ? respuesta : null;
}
